import { render, staticRenderFns } from "./TabbarItem.vue?vue&type=template&id=0f3a113c&"
import script from "./TabbarItem.vue?vue&type=script&lang=js&"
export * from "./TabbarItem.vue?vue&type=script&lang=js&"
import style0 from "./TabbarItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports